import { useContext } from "react";

import { StorageManagerContext } from "@lib/storageManager";

export const useStorageManager = () => {
  return useContext(StorageManagerContext);
};
